module.exports = __webpack_public_path__ + "static/img/software35.f4fe6369.png";